module.exports = __webpack_public_path__ + "img/spinner.f388a7cd.svg";